import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const ModuleSubtopicVonNeumannHarvard = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
    <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Von Neumann Machine and Harvard Architecture" 
      videos={[
        "https://www.youtube.com/embed/GiFvHGW5tAI",
        "https://www.youtube.com/embed/QMFlF-9ji8Y",
      ]}
      takeaways={[
        { text: "Directly remember the difference between Von Neumann and Harvard Architecture." },
      ]}
      questions={[]} // Add questions if needed
      exampleVideos={[]} // Add example question videos if needed
    />
);
}

export default ModuleSubtopicVonNeumannHarvard;
